import { Option } from 'funfix-core';
import { Record } from 'immutable';
import { makeInstallableAppByUrlIdentifier } from '../InstallableAppIdentifier';
import { makePendingConfirmationInstallStatus } from './InstallStatus';
export const INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE = 'INSTALLABLE_APP_BY_MANUAL_URL';
export const makeInstallableAppByManualUrl = Record({
  installableApp: Option.empty(),
  installableAppByUrlId: makeInstallableAppByUrlIdentifier(),
  installedApp: Option.empty(),
  retrievalId: 0,
  status: makePendingConfirmationInstallStatus()
});
export const makeInstallableAppByManualUrlInstallMode = Record({
  type: INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE,
  installableAppByManualUrl: Option.empty()
});